import { Button, dialog } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import UsersPresenter from "./UsersPresenter";
import BiometricDevices from "./user-table/BiometricDevices";
import BiometricFinger from "./user-table/BiometricFinger";
import InputFactory from "../../../components/InputFactory";
import ExportCSVFunction from "../../../components/ExportCSVFunction";
import Progress from "../../../components/Progress";

class UserPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new UsersPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      openDeviceModal: false,
      openFingerModal: false,
      bioData: {},
      objects: [],
      count: 0,
      limit: 50,
      current: 1,
      employees: [],
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();

    // const users = await findObjectUseCase().execute("users", {
    //   where: {
    //     account: { $exists: false }, //exclude account from jobPortal
    //     $or: [
    //       {
    //         fingerPrint: {
    //           $exists: false,
    //         },
    //       },
    //       { fingerPrint: { $size: 0 } },
    //     ],
    //     // fingerPrint: {
    //     //   $exists: true,
    //     //   $not: { $size: 0 },
    //     // },
    //   },
    //   keys: [
    //     "employee.Firstname",
    //     "employee.Middlename",
    //     "employee.surname",
    //     "username",
    //     "fingerPrint",
    //   ],
    //   include: ["employee"],
    // });
    // console.log("Registered: ", users);
    // this.setState({ registerdEmp: users });

    // const onData = (objects) => {
    //   this.setState((prevState) => ({ ...prevState, employees: objects }));
    // };

    // const limit = 500;
    // let skip = 0;
    // let hasMore = true;

    // try {
    //   while (hasMore) {
    //     const employees = await findObjectUseCase().execute(
    //       "employees",
    //       {
    //         keys: ["Firstname", "Middlename", "surname"],
    //         limit,
    //         skip,
    //       }
    //       // { timeout: 100000, onData }
    //     );
    //     if (!employees || employees.length === 0) {
    //       hasMore = false;
    //     }
    //     console.log("EMPLOY: ", employees);
    //     this.setState((prevState) => ({
    //       employees: [...prevState.employees, ...employees],
    //     }));
    //     skip += limit;
    //   }
    // } catch (e) {
    //   console.error(e.message || e);
    // }
  }

  getCollectionName() {
    return "users";
  }

  handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
  }

  // delete function
  async handleDeleteData(data) {
    await this.presenter.deleteObjectUseCase.execute("users", data.id);
    this.refetchData();
  }

  async handleAssignFaceRegistration(object) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Face Enrollment Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Are you sure you want to register {object?.employee?.Firstname}{" "}
              face?
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={async () => {
                object.faceRegister = true;
                console.log("OBEJCT: ", object);
                await upsertUseCase().execute("users", object);
                dialog.close();
                this.refetchData();
                this.showSuccess("Success");
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
  }

  // assign Biometric device
  handleBiometrics(data) {
    this.setState({ openDeviceModal: true, bioData: data });
  }

  // assign Biometric device
  handleBiometricFinger(data) {
    this.setState({ openFingerModal: true, bioData: data });
  }

  async handleAddUser(id) {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.onChangeFilter();
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "employee") {
      this.onChangeFilter("Pointer", value, "employee");
    } else if (field === "username") {
      this.onChangeFilter("String", value, "username");
    }
  }

  async exportUserRegistered() {
    const schema = this.getSchema("users");
    const exportField = ["employee", "username"];
    // console.log("USERS: ", users);
    ExportCSVFunction(
      this.state.registerdEmp,
      "Registered Employee",
      schema,
      exportField,
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    // console.log("OJ", objects);
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}s
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                {/* <SearchSelect
                    value={this.state.employee?.name}
                    onChange={(value) => this.onChangeOption("employee", value)}
                    focus={true}
                    onClickClear={() => this.onChangeOption("employee", "")}
                    placeholder="Employee"
                    options={this.state.employees.map((item) => {
                      const empName = `${item.Firstname} ${
                        item.Middlename || ""
                      } ${item.surname}`;
                      return {
                        label: empName,
                        value: { id: item.id, name: empName },
                      };
                    })}
                  />
                  <div>
                    <InputFactory
                      type="String"
                      placeHolder="Username"
                      // object={{schema: _schema}}
                      onChange={(value) =>
                        this.onChangeOption("username", value)
                      }
                    />
                  </div> */}
                <div className="d-flex mb-1">
                  {Object.keys(schema.filters || {}).map((field) => {
                    let { type, ...options } = schema.filters[field];
                    return (
                      <InputFactory
                        key={field}
                        className="ms-1"
                        type={type}
                        field={field}
                        where={{}}
                        onChange={this.onChangeFilter.bind(this, type)}
                        {...options}
                      />
                    );
                  })}
                  {/* <SearchSelect
                    value={this.state.employee?.name}
                    onChange={(value) => this.onChangeOption("employee", value)}
                    focus={true}
                    onClickClear={() => this.onChangeOption("employee", "")}
                    placeholder="test"
                    options={this.state.employees.map((item) => {
                      const empName = `${item?.Firstname} ${
                        item?.Middlename || ""
                      } ${item?.surname}`;
                      return {
                        label: empName,
                        value: { id: item.id, name: empName },
                      };
                    })}
                  /> */}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}s</h4>
                    <div className="gap-2" style={{ marginLeft: "auto" }}>
                      {/* <Button
                        onClick={this.exportUserRegistered.bind(this)}
                        className="btn btn-light me-2"
                        // onClick={this.onClickAdd.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> export Employee{" "}
                        {schema.label}
                      </Button> */}
                      <Button
                        onClick={this.handleAddUser.bind(this)}
                        // onClick={this.onClickAdd.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> Add {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                // separateEmployee={this.handleBiometricFinger.bind(this)}
                ofTraining={(data) => this.presenter.removeFingerPrint(data)}
                objectId={this.handleDeleteData.bind(this)}
                // ofAppearance={this.handleAssignFaceRegistration.bind(this)}
                editId={this.handleEditData.bind(this)}
                hrAction={(data) => this.handleBiometrics(data)}
                stepIncrement={(data) => this.presenter.handleResetPass(data)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "user",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "createdAt",
                    "updatedAt",
                    "sync",
                    "isEnable",
                    "employeeAgencyNum",
                    "isReset"
                  ],
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />

              <div>
                {this.state.openDeviceModal && (
                  <BiometricDevices
                    closeModal={() => this.setState({ openDeviceModal: false })}
                    bioData={this.state.bioData}
                    refetchData={() => this.refetchData()}
                  />
                )}
              </div>
              <div>
                {this.state.openFingerModal && (
                  <BiometricFinger
                    closeModal={() => this.setState({ openFingerModal: false })}
                    refetchData={() => this.refetchData()}
                    bioData={this.state.bioData}
                  />
                )}
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(UserPage);
